export default __webpack_public_path__ + "static/media/chatbot.87d82cc7.png";